// src/layout/MobileTabBar.jsx
// スマホ用の下部タブバー【2026-07-21】
// - 800px以下でのみ表示（CSS制御）
// - ロール別メニューの3項目 + 「メニュー」(ドロワーを開く) の4タブ
// 【2026-11-02】menu.js で tab を付けた項目を出す（先生: ダッシュボード・出席受付・出席集計）。
//   tab の項目が 3 つに足りないロールは、メニューの先頭から埋める（学生・教務は今までどおり先頭 3 つ）
import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { getMenuItems, isClassSummaryPath } from '../config/menu';
import Icon from '../components/Icon';
import useActionCount from '../hooks/useActionCount';

export default function MobileTabBar({ user, onMenuClick = () => {} }) {
  const location = useLocation();
  const todoCount = useActionCount(user);   // 要対応がタブに無いとき、「メニュー」に点を付ける【2026-11-02】
  const all = getMenuItems(user);
  const items = all.filter(it => it.tab).slice(0, 3);
  for (const it of all) { if (items.length >= 3) break; if (!items.includes(it)) items.push(it); }
  let lastClassId = null;
  try { lastClassId = localStorage.getItem('lastClassId'); } catch (e) { /* 参照できなくても動く */ }
  const hrefFor = (it) => it.classSection
    ? '/classes/' + (lastClassId || 'all') + '/' + it.classSection
    : (it.href || it.to);
  return (
    <nav className="mobile-tabbar">
      {items.map(it => (
        <NavLink
          key={it.to}
          to={hrefFor(it)}
          end={it.to === '/'}
          className={({ isActive }) => 'mobile-tab' +
            ((it.classSection ? isClassSummaryPath(location.pathname) : isActive) ? ' active' : '')}
        >
          <span className="mobile-tab-icon"><Icon name={it.icon} size={22} />
            {it.badge === 'todo' && todoCount > 0 && <span className="mobile-tab-dot" aria-label={`要対応 ${todoCount}件`} />}
          </span>
          <span className="mobile-tab-label">{it.label}</span>
        </NavLink>
      ))}
      <button className="mobile-tab" onClick={onMenuClick}>
        <span className="mobile-tab-icon"><Icon name="menu" size={22} />
          {todoCount > 0 && !items.some(it => it.badge === 'todo') && <span className="mobile-tab-dot" aria-label={`要対応 ${todoCount}件`} />}
        </span>
        <span className="mobile-tab-label">メニュー</span>
      </button>
    </nav>
  );
}
